/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import TokenType from './TokenType';

/**
 * The EventsControllerDtoEventInvitationInfosCreateRequest model module.
 * @module model/EventsControllerDtoEventInvitationInfosCreateRequest
 * @version 1.0
 */
class EventsControllerDtoEventInvitationInfosCreateRequest {
    /**
     * Constructs a new <code>EventsControllerDtoEventInvitationInfosCreateRequest</code>.
     * @alias module:model/EventsControllerDtoEventInvitationInfosCreateRequest
     */
    constructor() { 
        
        EventsControllerDtoEventInvitationInfosCreateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventInvitationInfosCreateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventInvitationInfosCreateRequest} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventInvitationInfosCreateRequest} The populated <code>EventsControllerDtoEventInvitationInfosCreateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventInvitationInfosCreateRequest();

            if (data.hasOwnProperty('invNo')) {
                obj['invNo'] = ApiClient.convertToType(data['invNo'], 'Number');
            }
            if (data.hasOwnProperty('invitationLimit')) {
                obj['invitationLimit'] = ApiClient.convertToType(data['invitationLimit'], 'Number');
            }
            if (data.hasOwnProperty('regDuration')) {
                obj['regDuration'] = ApiClient.convertToType(data['regDuration'], 'Number');
            }
            if (data.hasOwnProperty('inviterXper')) {
                obj['inviterXper'] = ApiClient.convertToType(data['inviterXper'], 'Number');
            }
            if (data.hasOwnProperty('inviterPer')) {
                obj['inviterPer'] = ApiClient.convertToType(data['inviterPer'], 'Number');
            }
            if (data.hasOwnProperty('inviterItem1')) {
                obj['inviterItem1'] = ApiClient.convertToType(data['inviterItem1'], 'Number');
            }
            if (data.hasOwnProperty('inviterItem1Count')) {
                obj['inviterItem1Count'] = ApiClient.convertToType(data['inviterItem1Count'], 'Number');
            }
            if (data.hasOwnProperty('inviterItem2')) {
                obj['inviterItem2'] = ApiClient.convertToType(data['inviterItem2'], 'Number');
            }
            if (data.hasOwnProperty('inviterItem2Count')) {
                obj['inviterItem2Count'] = ApiClient.convertToType(data['inviterItem2Count'], 'Number');
            }
            if (data.hasOwnProperty('invitedXper')) {
                obj['invitedXper'] = ApiClient.convertToType(data['invitedXper'], 'Number');
            }
            if (data.hasOwnProperty('invitedPer')) {
                obj['invitedPer'] = ApiClient.convertToType(data['invitedPer'], 'Number');
            }
            if (data.hasOwnProperty('invitedItem1')) {
                obj['invitedItem1'] = ApiClient.convertToType(data['invitedItem1'], 'Number');
            }
            if (data.hasOwnProperty('invitedItem1Count')) {
                obj['invitedItem1Count'] = ApiClient.convertToType(data['invitedItem1Count'], 'Number');
            }
            if (data.hasOwnProperty('invitedItem2')) {
                obj['invitedItem2'] = ApiClient.convertToType(data['invitedItem2'], 'Number');
            }
            if (data.hasOwnProperty('invitedItem2Count')) {
                obj['invitedItem2Count'] = ApiClient.convertToType(data['invitedItem2Count'], 'Number');
            }
            if (data.hasOwnProperty('beginAt')) {
                obj['beginAt'] = ApiClient.convertToType(data['beginAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('eventType')) {
                obj['eventType'] = ApiClient.convertToType(data['eventType'], 'Number');
            }
            if (data.hasOwnProperty('rewardRatio')) {
                obj['rewardRatio'] = ApiClient.convertToType(data['rewardRatio'], 'Number');
            }
            if (data.hasOwnProperty('rewardLimit')) {
                obj['rewardLimit'] = ApiClient.convertToType(data['rewardLimit'], 'Number');
            }
            if (data.hasOwnProperty('tokenType')) {
                obj['tokenType'] = TokenType.constructFromObject(data['tokenType']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventInvitationInfosCreateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventInvitationInfosCreateRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} invNo
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['invNo'] = undefined;

/**
 * @member {Number} invitationLimit
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['invitationLimit'] = undefined;

/**
 * @member {Number} regDuration
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['regDuration'] = undefined;

/**
 * @member {Number} inviterXper
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['inviterXper'] = undefined;

/**
 * @member {Number} inviterPer
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['inviterPer'] = undefined;

/**
 * @member {Number} inviterItem1
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['inviterItem1'] = undefined;

/**
 * @member {Number} inviterItem1Count
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['inviterItem1Count'] = undefined;

/**
 * @member {Number} inviterItem2
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['inviterItem2'] = undefined;

/**
 * @member {Number} inviterItem2Count
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['inviterItem2Count'] = undefined;

/**
 * @member {Number} invitedXper
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['invitedXper'] = undefined;

/**
 * @member {Number} invitedPer
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['invitedPer'] = undefined;

/**
 * @member {Number} invitedItem1
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['invitedItem1'] = undefined;

/**
 * @member {Number} invitedItem1Count
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['invitedItem1Count'] = undefined;

/**
 * @member {Number} invitedItem2
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['invitedItem2'] = undefined;

/**
 * @member {Number} invitedItem2Count
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['invitedItem2Count'] = undefined;

/**
 * @member {Date} beginAt
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['beginAt'] = undefined;

/**
 * @member {Date} endAt
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['endAt'] = undefined;

/**
 * @member {Date} createdAt
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['createdAt'] = undefined;

/**
 * @member {Number} eventType
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['eventType'] = undefined;

/**
 * @member {Number} rewardRatio
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['rewardRatio'] = undefined;

/**
 * @member {Number} rewardLimit
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['rewardLimit'] = undefined;

/**
 * @member {module:model/TokenType} tokenType
 */
EventsControllerDtoEventInvitationInfosCreateRequest.prototype['tokenType'] = undefined;






export default EventsControllerDtoEventInvitationInfosCreateRequest;

